"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findOperatorAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("../../constants");
const findOperatorAddress = async (base, programID = constants_1.QUARRY_ADDRESSES.Operator) => {
    return await web3_js_1.PublicKey.findProgramAddress([anchor_1.utils.bytes.utf8.encode("Operator"), base.toBytes()], programID);
};
exports.findOperatorAddress = findOperatorAddress;
//# sourceMappingURL=pda.js.map